export function ValidatePassword(password: string) {
  var strength = password.length * 2.5;

  if (/.*[a-z].*/.test(password)) {
    // Enthält kleine Buchstaben
    strength = strength + 20;
  }
  if (/.*[A-Z].*/.test(password)) {
    // Enthält große Buchstaben
    strength = strength + 20;
  }
  if (/.*[0-9].*/.test(password)) {
    // Enthält Zahlen
    strength = strength + 20;
  }
  if (/[^a-zA-Z0-9]/.test(password)) {
    // Enthält Sonderzeichen
    strength = strength + 20;
  }
  return strength;
}
